import { translateObject } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
import { receiptMap } from '../translationMaps';
function formatReceipt(data) {
  var receipt = data.data;
  var translated = translateObject(receiptMap, receipt);
  return translated;
}

/**
 * Fetch a singular receipt by transactionId
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {String} transactionId The identifier for the transaction
 * @returns {Promise} Unresolved Promise from the API.
 */
function byTransactionId($axios, transactionId) {
  if (!transactionId) {
    throw new Error('Prop `transactionId` is required in `receipt.byTransactionId`');
  }
  return $axios.get(urls.apiV2("/transactions/".concat(transactionId, "/receipt"))).then(prop('data')).then(formatReceipt);
}
export default {
  byTransactionId: withAxios(byTransactionId)
};